export default __webpack_public_path__ + "static/media/instagram_sc_1.d08e6536.png";